import React from 'react';
import { SmartAuthPageProps } from './components/auth/auth.type';
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  UpdatePasswordPage,
  ConfirmEmailPage,
  ResetPasswordPage,
} from './components';
import { CardProps, FormProps, LayoutProps } from 'antd';

export type AuthProps = SmartAuthPageProps<LayoutProps, CardProps, FormProps> & {
  renderContent?: (content: React.ReactNode, title: React.ReactNode) => React.ReactNode;
  title?: React.ReactNode;
};
export const AuthPage: React.FC<AuthProps> = props => {
  const { type } = props;
  const renderView = () => {
    switch (type) {
      case 'register':
        return <RegisterPage {...props} />;
      case 'forgotPassword':
        return <ForgotPasswordPage {...props} />;
      case 'resetPassword':
        return <ResetPasswordPage {...props} />;
      case 'updatePassword':
        return <UpdatePasswordPage {...props} />;
      case 'confirmEmail':
        return <ConfirmEmailPage {...props} />;
      default:
        return <LoginPage {...props} />;
    }
  };

  return <>{renderView()}</>;
};
